import React from "react";

const Header = () => {
  return (

    <section className="header-section">
      <div className="container">
        <h5>
          RETROSPECTIVE MEDICAL RECORD REVIEW OF PATIENTS WITH METHYLMALONIC ACIDEMIA (MMA) UNDERGOING LIVER OR COMBINED LIVER-KIDNEY TRANSPLANTS (LT OR LKT)
        </h5>
        <h4>Case Report Form (CRF)</h4>
      </div>
    </section>
  );
};

export default Header;
